
export default {
  name: 'PrivacyPolicy',

  head: {
    title: 'Privacy Policy',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Our privacy policy sets out how we handle your personal information when you are using Motion Routes.',
      },
      {
        hid: 'keywords',
        name: 'keywords',
        keywords:
          'motion routes, apps manager, script, adobe, plugin, adobe express, after effects, motion graphics, adobe after effects, adobe plugin, adobe express plugin, adobe express script',
      },
    ],
  },
};
